import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalizeRouterService } from 'localize-router';
import { ApiService } from '../../../app/shared/_services/api.service';

@Component({
  selector: 'app-ricerca-generica',
  templateUrl: './ricerca-generica.component.html',
  styles: []
})
export class RicercaGenericaComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private api: ApiService,
    private localize: LocalizeRouterService
  ) { }

  termine = '';
  risultati = [];

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params.q) {
        this.termine = params.q;
        this.cerca();
      }
    })
  }

  cerca() {
    this.api.search({
      "titolo": this.termine,
      "cdLingua": this.localize.parser.currentLang.toUpperCase(),
    }).subscribe(res => {
      this.risultati = res || [];
      console.log(this.risultati);
    })
  }

}
